import React from 'react'

import { Link, useNavigate } from 'react-router-dom'

import style from './ReviewButtons.module.css'

import { Button } from 'common/components'
import { useAppDispatch } from 'common/hooks'
import { Paths } from 'common/routes'
import { resetSimulator } from 'features/simulator'

type PropsType = {
  nextTaskId: string
}

export const ReviewButtons = ({ nextTaskId }: PropsType) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const restartButtonHandler = () => {
    dispatch(resetSimulator())
  }

  const goToNextTask = () => {
    navigate(`${Paths.Simulator}${nextTaskId}`)
  }

  return (
    <div className={style.box}>
      <div>
        <Link className={style.link} to="/">
          Статистика
        </Link>
        <Button onClick={restartButtonHandler}>Повторить</Button>
      </div>
      <Button onClick={goToNextTask} autoFocus accent>
        Продолжить
      </Button>
    </div>
  )
}
